//=include smooth-scroll/dist/smooth-scroll.min.js
//=include sweetalert/dist/sweetalert.min.js
//=require gumshoejs/dist/js/gumshoe.js
//=include perfect-scrollbar/dist/perfect-scrollbar.min.js

//=require ./js/calc-bottom-offset.js

if (process.env.NODE_ENV !== 'development') {
	//=require ./3d-party/*.js
	//=include @maxpay/lib/util/analytics.js
}

//=require ./js/*.js
